import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  CreateMailOrderPharmacyDefinition,
  GetMailOrderPharmacyDefinitions,
  PreviewMailOrderPharmacyDefinition,
  ResolveMailOrderPharmacyDefinition,
  SetMailOrderPharmacyDefinitionActive,
  UpdateMailOrderPharmacyDefinition,
} from "Services/API/MailOrderPharmacies.service";

export const mailOrderPharmacyKeys = {
  all: ["mailOrderPharmacyDefinitions"],
};

export const useMailOrderPharmacyDefinitions = () =>
  useQuery(mailOrderPharmacyKeys.all, GetMailOrderPharmacyDefinitions);

const useInvalidatingMutation = (mutationFn) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: mailOrderPharmacyKeys.all }),
  });
};

export const usePreviewMailOrderPharmacyDefinition = () =>
  useMutation({ mutationFn: PreviewMailOrderPharmacyDefinition });

export const useCreateMailOrderPharmacyDefinition = () =>
  useInvalidatingMutation(CreateMailOrderPharmacyDefinition);

export const useUpdateMailOrderPharmacyDefinition = () =>
  useInvalidatingMutation(({ id, payload }) => UpdateMailOrderPharmacyDefinition(id, payload));

export const useSetMailOrderPharmacyDefinitionActive = () =>
  useInvalidatingMutation(({ id, active }) => SetMailOrderPharmacyDefinitionActive(id, active));

export const useResolveMailOrderPharmacyDefinition = () =>
  useInvalidatingMutation(ResolveMailOrderPharmacyDefinition);

